import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { borderRadius, boxShadows } from '@synoptic/ui-kit/tokens.js';
import { style } from '@vanilla-extract/css';

export const card = style({
  outline: `1px solid ${themeVars.container.border.default}`,
  backgroundColor: themeVars.container.primary.background.idle,
  boxShadow: boxShadows.default,
  borderRadius: borderRadius.r16,
});

export const cardHoverable = style({
  transition: 'box-shadow 0.2s',

  ':hover': {
    boxShadow: boxShadows.hover,
  },
});
